import cn from '@integrations/classnames'
import type { HTMLAttributes, ReactNode } from '@integrations/react'

import styles from './RecurringModalSurface.module.scss'

interface SurfaceProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode
}

function RecurringModalSurface({ title, children, className, ...props }: SurfaceProps) {
  return (
    <div className={cn(styles['surface'], 'recurring-modal-surface', className)} {...props}>
      <h3>{title}</h3>
      {children}
    </div>
  )
}

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  amount?: boolean
}

function RecurringModalCard({ amount = false, children, className, ...props }: CardProps) {
  return (
    <div
      className={cn(
        styles['card'],
        'recurring-modal-card',
        { [styles['amount-card']]: amount, 'recurring-modal-amount-card': amount },
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

function RecurringModalFooter({ children, className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn(styles['footer'], 'recurring-modal-footer', className)} {...props}>
      {children}
    </div>
  )
}

export { RecurringModalCard, RecurringModalFooter, RecurringModalSurface }
